import React from "react";
import { Chip, Stack, TableCell, TableHead, TableRow, styled, Typography, Avatar } from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';



export default function EoiItem({ data, index }) {

    return (
        <TableRow sx={{background: index % 2 == 0 ? "#FaFaFa" : "#FFFFFF"}}>
            <TableCell>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body1" color="initial">{data?.point}</Typography>
                </Stack>
            </TableCell>
            <TableCell>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body1" color="initial">{data?.count}</Typography>
                </Stack>
            </TableCell>
        </TableRow>
    );
}

